import { render, staticRenderFns } from "./Mcp.vue?vue&type=template&id=5f5a207a&scoped=true&"
import script from "./Mcp.vue?vue&type=script&lang=js&"
export * from "./Mcp.vue?vue&type=script&lang=js&"
import style0 from "./Mcp.vue?vue&type=style&index=0&id=5f5a207a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5a207a",
  null
  
)

export default component.exports